import React from "react";
import { Star, X } from "@phosphor-icons/react";
import SymbolSearch from "./SymbolSearch";

const KEY = "gmsm_watchlist";

export function loadWatchlist() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}
export function saveWatchlist(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

export default function WatchlistManager({ items, onChange, onSelect }) {
  const add = (sym) => {
    const s = String(sym || "").trim().toUpperCase();
    if (!s) return;
    if (items.includes(s)) return;
    onChange([...items, s]);
  };
  const remove = (s) => {
    onChange(items.filter((x) => x !== s));
  };
  return (
    <div className="bg-surface border border-white/10 p-5" data-testid="watchlist">
      <div className="flex items-center gap-2 mb-3">
        <Star size={16} weight="fill" color="#FFCC00" />
        <h3 className="heading text-lg font-semibold">Watchlist</h3>
        <span className="overline ml-auto">local</span>
      </div>
      <div className="mb-3">
        <SymbolSearch
          onAdd={add}
          onSelect={(s) => onSelect && onSelect(s)}
          placeholder="Search any ticker · e.g. RELIANCE, AAPL, BTC"
          testid="watchlist-search"
        />
      </div>
      {items.length === 0 ? (
        <div className="overline py-4 text-center">empty list</div>
      ) : (
        <div className="space-y-1">
          {items.map((s) => (
            <div
              key={s}
              role="button"
              onClick={() => onSelect && onSelect(s)}
              className="flex items-center justify-between px-3 py-2 border border-white/5 hover:border-white/15 hover:bg-white/[0.03] transition-colors duration-150 cursor-pointer"
              data-testid={`watchlist-item-${s}`}
            >
              <span className="mono text-sm">{s}</span>
              <button
                onClick={(e) => { e.stopPropagation(); remove(s); }}
                className="text-white/40 hover:text-bearish p-0.5"
                data-testid={`watchlist-remove-${s}`}
              >
                <X size={14} weight="bold" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
